import API from 'services/api'
export default class Users extends API {
	async register({
		data,
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
	}) {
		onStart()
		try {
			const options = {
				auth: false,
				data,
				method: 'POST',
				url: '/users/auth/register/',
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async login({
		data,
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
	}) {
		onStart()
		try {
			const options = {
				auth: false,
				data,
				method: 'POST',
				url: '/user/signin/',
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async logout({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
	}) {
		onStart()
		try {
			const options = {
				method: 'DELETE',
				url: '/users/auth/logout/',
			}
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async getProfile({
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
	}) {
		onStart()
		try {
			const options = { url: '/user/profile' }
			const response = await this.baseAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
	async getUserStatus({
		tin,
		onEnd = () => {},
		onError = () => {},
		onStart = () => {},
		onSuccess = () => {},
	}) {
		onStart()
		try {
			const date = new Date().toISOString().slice(0, 10).replace(/-/g, '.')
			const lang = localStorage.getItem('i18nextLng') || 'uz'
			const options = {
				url: `/edo-service/api/v1/Utils/nds/Status?tin=${tin}&date=${date}&lang=${lang}`,
			}
			const response = await this.cfoAPI(options)
			onSuccess(response)
		} catch (e) {
			onError(e)
		} finally {
			onEnd()
		}
	}
}
